import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface TubingBookingPopupModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Tubing booking entry point.
 *
 * Routes into the first-party booking flow at /book-now with the tubing step
 * pre-targeted. The original Checkfront popup is preserved at
 * src/components/booking-fallback/TubingBookingPopupModal.tsx.
 */
export function TubingBookingPopupModal({ open, onOpenChange }: TubingBookingPopupModalProps) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    onOpenChange(false);
    navigate("/book-now?focus=tubing");
  }, [open, onOpenChange, navigate]);

  return null;
}
